<template>
  <div class="wrapper">
    <parallax class="section page-header header-filter" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item text-center"
          >
            <h1 class="title">I don’t know who I am yet.</h1>
            <br />
            <md-button
              class="md-info button-black md-lg"
              @click="scrollToAnchorPoint('help', 'Banner: Help Me')"
              >Help Me</md-button>
          </div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section">
        <div class="container">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto text-center"
            >
              <h2 class="title text-center">I am a shark.</h2>

<p class="text-left">Hey, I am Joey Shark. I don’t know much about myself. I know I’m a shark, obviously, and that I’m named after a human who is also called Joey. It’s really an honor to be named after her, because she’s really great. But, that's about all I know. I need the Atlantic Shark Institute to find me and we need some money to make that happen, so if you’ve got some extra cash contact Joe and he’ll pass it along — scroll down a bit and you’ll see a link to reach him.</p>

<p class="text-left">What are my hopes and dreams? Well, my own hash tag would be pretty cool, but not sure how that works. So, instead of that I’d want Joey, my human namesake, to know that she’s awesome just like me and I’d want her to know how grateful I am that she is such a shark advocate. If you see her, give her a high five for being awesome.</p>

<p class="text-left">What do I spend my time doing? To be honest, I’m a bit of a worrier. Sometimes I get sad or scared for me and my ocean friends. You know, we aren’t always treated well by humans. I think they just don’t get us? But, I know I’m not alone in my grief; the Atlantic Shark Institute, my ocean friends, and my human buddies get me, so that makes me feel better. But, mostly I spend my time traveling. A lot. Like, it would blow your mind if you knew how far I go each year.</p>

<p class="text-left">I’ll keep everyone updated as I know more about who I am. You can check back here or join the email newsletter for getting notified about events in my life. Of course, I’ll be on all the socials too.</p>

            </div>
          </div>
        </div>
      </div>

      <div class="section" ref="help">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto">
              <h2 class="text-center title">Help me.</h2>
              <p class="text-left">
                I need the Atlantic Shark Institute to find me, but to do that we need money. Our funding goal is $5,000. I’ve asked Joe (Joey’s hub) to handle collecting the funds and get them over to the institute. You can contact him below.
              </p>

              <p class="text-left">
                Also, go learn a fact about sharks and tell somebody. Or, tell a joke, like "Why can’t sharks read?"
                "Because they don’t have school!"
              </p>
              <div class="md-layout">
                <div class="md-layout-item md-size-100 mx-auto text-center">
                  <a href="mailto:iamjoeyshark@gmail.com" @click="plausible('Section: Help Me: Email Joe')">
                    <md-button class="md-info button-black">Email Joe</md-button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="section">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-50 md-small-size-100 mx-auto">
              <img :src="asiLogo" alt="Atlantic Shark Institute" />
            </div>
            <div class="md-layout-item md-size-50 md-small-size-100 mx-auto">
              <h2 class="text-left title">My friend, the Atlantic Shark Institute.</h2>
              <p class="text-left">
                The Atlantic Shark Institute is helping find me. They are really awesome (just like me and my namesake). Take some time to read up about them and the good work they do to help research sharks on the US East Coast.
              </p>
              <div class="md-layout">
                <div class="md-layout-item md-size-33 md-small-size-100 mx-auto text-left">
                  <a href="https://www.atlanticsharkinstitute.org">
                    <md-button class="md-info button-black">Learn More</md-button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>









    </div>
  </div>
</template>

<script>
export default {
  bodyClass: "landing-page",
  props: {
    header: {
      type: String,
      default: require("@/assets/img/shark-background-align-top.png")
    },
    asiLogo: {
      type: String,
      default: require("@/assets/img/atlantic-shark-institute-square2.png")
    }
  },
  data() {
    return {
      name: null,
      email: null,
      message: null
    };
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  },
  methods: {
    scrollToAnchorPoint(refName, eventName) {
      this.plausible(eventName);
      const el = this.$refs[refName];
      el.scrollIntoView({ behavior: 'smooth'});
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
</style>
